import React from 'react';
import { linkGroups, socialLinks } from './FooterData';
import FooterBottom from './FooterBottom';
import FooterBrand from './FooterBrand';
import FooterColumn from './FooterColumn';

const Footer = (): JSX.Element => (
  <footer className="global-footer" role="contentinfo">
    <div className="footer-container">
      <div className="footer-grid">
        <FooterBrand />

        {linkGroups.map((group) => (
          <FooterColumn key={group.key} group={group} />
        ))}
      </div>

      <div className="footer-divider" />

      <FooterBottom socialLinks={socialLinks} />
    </div>

    <div className="footer-accent" aria-hidden="true" />
  </footer>
);

export default Footer;
